<div class="outer-content">
<div *ngIf="displayPage" role="dialog" id="modal-dialog" aria-labelledby="dialog-label" aria-modal="true" class="wh-auto">
  <div class="float-left bg-white card-background wh-auto">
    <form [formGroup]="diabetesForm" autocomplete="off" role="form" class="fieldHeight">
      <app-content-top-nav [closeBtnEnabled]="true" [visibleBackNav]='showBackBtn' [enableBackNav]='true'
        (onCloseClickHandler)="closePage()"></app-content-top-nav>
      <div class="col-md-12 clear-all title-wrapper margin-bottom-50">
        <h1 class="title-text custom-header-h2 responsive-text-8" id="diabetes-header">{{selectedTitle}}</h1>
      </div>
      <div class="col-md-12 clear-all content-wrapper">
        <p class="to-give-you-the-best" id="diabetes-introduction">
          {{contentData.introduction}}
        </p>
        <ng-container *ngFor="let list of contentData.details">
          <div class="col-md-12 clear-all">
            <p class="you-will-need" id="diabetes-noteStatement">
              {{list.noteStatement}}
            </p>
          </div>
          <div class="col-md-12  clear-all The-year-your-diabet">
            <ul class="list-tick">
            <ng-container *ngFor="let section of list.textDetails">
             <li class="line-text" [id]="section.code">
               {{section.text}}</li>
            </ng-container>
            </ul>
            <!--<ng-container *ngFor="let section of list.textDetails">
              <div class="col-md-1 tick-blue">
                <img [id]="section.code+'-img-tick'" alt="tick" src="assets/images/tick copy.png" />
              </div>
              <div class="col-md-11">
                <span [id]="section.code">{{section.text}}</span>
              </div>
            </ng-container> -->
          </div>
        </ng-container>

        <div class="col-md-8 clear-all pdf-Container">
          <div class="col-md-12 clear-all pdf-content">
            <div class="col-md-8 clear-all">
              <div class="row Diabetes-Requirement">
                <span id="diabetes-pdfName">{{contentData.checkList.name}}</span>
              </div>
              <div class="row pdf-size1">
                <span id="diabetes-pdfSize">{{contentData.checkList.size}}</span>
              </div>
            </div>
            <div class="col-md-4 clear-all padding-left-40">
              <a>
                <img id="diabetesPdf" src="assets/images/guide.svg" alt="personalised Quote PDF" class="Guide reflect"
                  (click)="handlePDFDetails()" tabindex="0" (keyup.enter)="handlePDFDetails()">
              </a>
            </div>
          </div>
        </div>
      </div>


      <div class="col-md-12 underline margin-top"></div>
      <div class="col-md-12 clear-all">
        <div class="float-right">
          <app-content-bottom-nav (onNextHandler)="gotoNext()" [userInputDetail]="userInputDetail['buttonConfig']"
            [buttonType]="'normalCTA'"></app-content-bottom-nav>
        </div>
      </div>
    </form>
  </div>
</div>
</div>